import type { DeleteAccountResponseType } from 'unified-auth-core-lib';
import {
  defaultRegistry,
  type AuthProviderKey,
  type AuthRegistry,
} from './registry';

export interface DeleteAccountOptions {
  appId: number;
  providerKey?: AuthProviderKey;
  registry?: AuthRegistry;
}

export async function deleteAccount(
  accountId: number,
  options: DeleteAccountOptions
): Promise<DeleteAccountResponseType> {
  const { appId, providerKey, registry = defaultRegistry } = options;
  const components = await registry.resolveComponents(appId, providerKey);
  if (!components) {
    throw new Error(
      `[unified-auth] No auth provider found for appId: ${appId}`
    );
  }
  return components.deleteAccount(accountId);
}
